// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LoadingSpinner_Wrapper__cEeMr","Spinner":"LoadingSpinner_Spinner__1FRmh","rotate":"LoadingSpinner_rotate__K1Vlc"};